// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    getPricesApi,
    GetPricesApiModel,
    GetPricesApiParameter,
} from "@steiner/App/Services/PipeAndWireSheetPricingServices";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        productsIds?: string[];
    } & HasOnSuccess<GetPricesApiModel> &
        HasOnError,
    GetPricesApiParameter,
    GetPricesApiModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        productsIds: props.parameter?.productsIds,
    };
};

export const CallGetPrices: HandlerType = async props => {
    try {
        props.apiResult = await getPricesApi(props.apiParameter);
        props.apiResult.successful = true;
    } catch (error) {
        props.apiResult.successful = false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.();
    }
};

export const chain = [PopulateApiParameter, CallGetPrices, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const getPrices = createHandlerChainRunner(chain, "GetPrices");
export default getPrices;
